import { MOBILE } from '../../../constants/breakpoints';
export const serviceStyles = theme => ({
    switchButtonsWrapper: {
        display: 'flex',
        marginBottom: 16,
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
    },
    switchButton: {
        border: 'none',
        outline: 'none',
        boxShadow: 'none',
        background: '#fff',
        color: '#000',
        padding: '6px 16px',
        minWidth: 80,
        minHeight: 40,
        lineHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 600,
        fontSize: '15px',
        letterSpacing: '0%',
        cursor: 'pointer',
        borderRadius: '35px',
        marginRight: '35px',
        transition: 'background 0.2s, color 0.2s',
        '&:last-child': {
            marginRight: 0
        }
    },
    switchButtonSelected: {
        background: '#000',
        color: '#fff',
        '&:hover': {
            background: '#000',
            color: '#fff'
        },
        '&.Mui-disabled': {
            color: '#fff',
            opacity: 1
        }
    },
    servicesRoot: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        width: '100%',
        padding: '1rem',
        fontFamily: 'Inter, sans-serif',
        '& span': {
            // padding: '5% 0 0 5%',
            width: '100%',
            fontFamily: 'Inter, sans-serif'
        },
        [theme.breakpoints.up(MOBILE)]: {
            padding: '1rem',
            '& span': {
                padding: 0,
                width: '100%',
                marginBottom: '3%',
                fontFamily: 'Inter, sans-serif'
            }
        }
    },
    backButton: {
        padding: '0 0.5rem',
        backgroundColor: 'white',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        color: theme.palette.primary.main,
        '&:hover': {
            cursor: 'pointer'
        },
        [theme.breakpoints.up(MOBILE)]: {
            padding: '0 0 3% 0'
        }
    },
    optionsList: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& div': {
            border: '3px solid transparent'
        },
        '& div:nth-child(1)': {
            borderTopLeftRadius: '10px'
        },
        '& div:nth-last-child(2)': {
            borderBottomLeftRadius: '10px'
        },
        '& div:hover': {
            border: `3px solid ${theme.palette.primary.main}`
        },
        [theme.breakpoints.up(MOBILE)]: {
            border: '1px solid #ccc',
            borderRadius: '10px',
            height: '50vh',
            overflow: 'auto'
        }
    },
    actions: {
        display: 'none',
        justifyContent: 'flex-start',
        width: '100%',
        alignItems: 'center',
        marginTop: '2%',
        '& button': {
            marginRight: '2.5%',
            textTransform: 'none',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            '&:hover': {
                backgroundColor: theme.palette.primary.light
            }
        },
        [theme.breakpoints.up(MOBILE)]: {
            display: 'flex'
        }
    },
    optionName: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '1rem',
        '& button': {
            padding: 0,
            '& svg': {
                height: '18px',
                color: theme.palette.primary.main
            }
        }
    },
    name: {
        float: 'left',
        fontSize: '18px !important'
    },
    pricing: {
        float: 'right'
    },
    info: {
        margin: '-0.5rem 0.5rem',
        padding: '0.5rem',
        '&:hover': {
            color: '#2b78e4'
        }
    },
    infoIcon: {
        height: '18px',
        weight: '18px'
    },
    durationContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 6
    },
    durationText: {
        fontFamily: 'Inter !important',
        fontWeight: '500 !important',
        fontSize: '16px !important',
        lineHeight: '24px !important',
        letterSpacing: '0% !important',
        color: '#727272 !important',
        margin: '0 !important',
        padding: '0 !important',
        display: 'inline-block !important',
        verticalAlign: 'middle !important'
    },
    clockIcon: {
        width: 24,
        height: 24,
        display: 'inline-block !important',
        flexShrink: 0,
        verticalAlign: 'middle !important'
    },
    chevronIcon: {
        width: 6,
        height: 12,
        marginLeft: 16
    }
});
